export const environment = {
  production: false,
  version: "Dev_1.0",
  // apiUrl: "http://localhost:4000",
  apiUrl: "https://devapi.dairector.studio",
  // apiUrl: "https://betaapi.dairector.studio",
  // apiUrl: "https://api.dairector.studio",
  firebase: {
    apiKey: "AIzaSyBGDZkqi-nhMyCgXb1Mre778vDUX6skR7k",
    authDomain: "mediaflow-433118.firebaseapp.com",
    projectId: "mediaflow-433118",
    storageBucket: "mediaflow-433118.firebasestorage.app",
    messagingSenderId: "892418689188",
    appId: "1:892418689188:web:c9adf7a896ea2830c8be31",
  },
  // Web Push certificate public key (Firebase console > Cloud Messaging).
  firebaseVapidKey: "BHDa_sNr3-wkxoJ_DEY3IwI5AOYnvwUbYdpyfFm-O0JiG4y9FVsuir36LhT2FOHI8CnaE_BlPW4yTpPFwj2jvbQ",
};
